import { getQueryStringParameter, clearInputField } from '../../../helpers';

const clearAndHideMultipleFieldInputs = (arrayOfElements) => {
  arrayOfElements.forEach(($element, _) => {
    $element.addClass('d-none');
    $('input', $element).each((_, inputElement) => {
      clearInputField(inputElement);
    });
  });
};

$(() => {
  const $form = $('form#legal-profile-form');

  if ($form.length === 0 || getQueryStringParameter('id') !== 'company_type') {
    return;
  }

  const $companyTypeButtons = $('#company_type_buttons input[type=radio]', $form);
  const $pensionOrCharityButtons = $('#pension_or_charity_buttons', $form);
  const $charityInformationFields = $('#charity_information_fields', $form);
  const $pensionFundDirectorInformationFields = $('#pension_fund_director_information_fields', $form);
  const $pensionFundContactInformationFields = $('#pension_fund_contact_information_fields', $form);
  const $collectiveInvestorButtons = $('#collective_investor_buttons', $form);
  const $financialInstitutionButtons = $('#financial_institution_buttons', $form);
  const $publicEntityButtons = $('#public_entity_buttons', $form);
  const $govermentOversightInformationFields = $('#government_oversight_information_fields', $form);
  const $noGovernmentOversightFields = $('#no_government_oversight_fields', $form);
  const $hasGovernmentOversightButtons = $('#has_government_oversight_buttons', $form);
  const $appropriateGovernmentOversightFields = $('#appropriate_government_oversight_fields', $form);
  const $euPubliclyTradedCompanyButtons = $('#eu_publicly_traded_company_buttons', $form);
  const $euAffiliatedAubliclyTradedCompanyButtons = $('#eu_affiliated_publicly_traded_company_buttons', $form);
  const $euRegulatedPubliclyTradedCompanyButtons = $('#eu_regulated_publicly_traded_company_buttons', $form);
  const $euPrivateCompanyButtons = $('#eu_private_company_buttons', $form);
  const $euRegulatedPrivateTradedCompanyButtons = $('#eu_regulated_private_traded_company_buttons', $form);

  const $addPensionFundContact = $('#add_pension_fund_contact', $form);
  const $deletePensionFundContact = $('#delete_pension_fund_contact', $form);

  // Company type radio fields

  $companyTypeButtons.on('change', (e) => {
    if (e.target.value === 'pension_or_charity') {
      $pensionOrCharityButtons.removeClass('d-none');

      clearAndHideMultipleFieldInputs([
        $collectiveInvestorButtons,
        $financialInstitutionButtons,
        $publicEntityButtons,
        $govermentOversightInformationFields,
        $noGovernmentOversightFields,
        $hasGovernmentOversightButtons,
        $euPubliclyTradedCompanyButtons,
        $euAffiliatedAubliclyTradedCompanyButtons,
        $euRegulatedPubliclyTradedCompanyButtons,
        $euPrivateCompanyButtons,
        $euRegulatedPrivateTradedCompanyButtons,
      ]);
    } else if (e.target.value === 'collective_investor') {
      $collectiveInvestorButtons.removeClass('d-none');

      clearAndHideMultipleFieldInputs([
        $pensionOrCharityButtons,
        $charityInformationFields,
        $pensionFundDirectorInformationFields,
        $pensionFundContactInformationFields,
        $financialInstitutionButtons,
        $publicEntityButtons,
        $govermentOversightInformationFields,
        $noGovernmentOversightFields,
        $hasGovernmentOversightButtons,
        $euPubliclyTradedCompanyButtons,
        $euAffiliatedAubliclyTradedCompanyButtons,
        $euRegulatedPubliclyTradedCompanyButtons,
        $euPrivateCompanyButtons,
        $euRegulatedPrivateTradedCompanyButtons,
      ]);
    } else if (e.target.value === 'financial_institution') {
      $financialInstitutionButtons.removeClass('d-none');

      clearAndHideMultipleFieldInputs([
        $pensionOrCharityButtons,
        $charityInformationFields,
        $pensionFundDirectorInformationFields,
        $pensionFundContactInformationFields,
        $collectiveInvestorButtons,
        $publicEntityButtons,
        $govermentOversightInformationFields,
        $noGovernmentOversightFields,
        $hasGovernmentOversightButtons,
        $euPubliclyTradedCompanyButtons,
        $euAffiliatedAubliclyTradedCompanyButtons,
        $euRegulatedPubliclyTradedCompanyButtons,
        $euPrivateCompanyButtons,
        $euRegulatedPrivateTradedCompanyButtons,
      ]);
    } else if (e.target.value === 'public_entity') {
      $publicEntityButtons.removeClass('d-none');

      clearAndHideMultipleFieldInputs([
        $pensionOrCharityButtons,
        $charityInformationFields,
        $pensionFundDirectorInformationFields,
        $pensionFundContactInformationFields,
        $financialInstitutionButtons,
        $collectiveInvestorButtons,
        $euPubliclyTradedCompanyButtons,
        $euAffiliatedAubliclyTradedCompanyButtons,
        $euRegulatedPubliclyTradedCompanyButtons,
        $euPrivateCompanyButtons,
        $euRegulatedPrivateTradedCompanyButtons,
      ]);
    } else if (e.target.value === 'publicly_traded_company') {
      $euPubliclyTradedCompanyButtons.removeClass('d-none');

      clearAndHideMultipleFieldInputs([
        $pensionOrCharityButtons,
        $charityInformationFields,
        $pensionFundDirectorInformationFields,
        $pensionFundContactInformationFields,
        $collectiveInvestorButtons,
        $financialInstitutionButtons,
        $publicEntityButtons,
        $govermentOversightInformationFields,
        $noGovernmentOversightFields,
        $hasGovernmentOversightButtons,
        $euPrivateCompanyButtons,
        $euRegulatedPrivateTradedCompanyButtons,
      ]);
    } else if (e.target.value === 'private_company') {
      $euPrivateCompanyButtons.removeClass('d-none');

      clearAndHideMultipleFieldInputs([
        $pensionOrCharityButtons,
        $charityInformationFields,
        $pensionFundDirectorInformationFields,
        $pensionFundContactInformationFields,
        $collectiveInvestorButtons,
        $financialInstitutionButtons,
        $publicEntityButtons,
        $govermentOversightInformationFields,
        $noGovernmentOversightFields,
        $hasGovernmentOversightButtons,
        $euPubliclyTradedCompanyButtons,
        $euAffiliatedAubliclyTradedCompanyButtons,
        $euRegulatedPubliclyTradedCompanyButtons,
      ]);
    } else if (
      e.target.value === 'partnership'
      || e.target.value === 'limited_partnership'
      || e.target.value === 'foreign_trust'
    ) {
      clearAndHideMultipleFieldInputs([
        $pensionOrCharityButtons,
        $charityInformationFields,
        $pensionFundDirectorInformationFields,
        $pensionFundContactInformationFields,
        $collectiveInvestorButtons,
        $financialInstitutionButtons,
        $publicEntityButtons,
        $govermentOversightInformationFields,
        $noGovernmentOversightFields,
        $hasGovernmentOversightButtons,
        $euPubliclyTradedCompanyButtons,
        $euAffiliatedAubliclyTradedCompanyButtons,
        $euRegulatedPubliclyTradedCompanyButtons,
        $euPrivateCompanyButtons,
        $euRegulatedPrivateTradedCompanyButtons,
      ]);
    }
  });

  // Charity or pension option logic

  $pensionOrCharityButtons.on('change', (e) => {
    if (e.target.value === 'us_uk_charity') {
      $charityInformationFields.removeClass('d-none');

      clearAndHideMultipleFieldInputs([
        $pensionFundDirectorInformationFields,
        $pensionFundContactInformationFields,
      ]);
    } else if (e.target.value === 'pension_fund') {
      $pensionFundDirectorInformationFields.removeClass('d-none');
      $addPensionFundContact.removeClass('d-none');

      clearAndHideMultipleFieldInputs([$charityInformationFields]);
    } else {
      clearAndHideMultipleFieldInputs([
        $charityInformationFields,
        $pensionFundDirectorInformationFields,
        $pensionFundContactInformationFields,
      ]);
    }
  });

  $addPensionFundContact.on('click', (_e) => {
    $addPensionFundContact.addClass('d-none');
    $deletePensionFundContact.removeClass('d-none');

    $pensionFundContactInformationFields.removeClass('d-none');
  });

  $deletePensionFundContact.on('click', (_e) => {
    $deletePensionFundContact.addClass('d-none');
    $addPensionFundContact.removeClass('d-none');

    clearAndHideMultipleFieldInputs([$pensionFundContactInformationFields]);
  });

  // Public entity logic

  $('#users_profile_legal_legally_recognized_public_entity_true', $form).on('change', (_e) => {
    $hasGovernmentOversightButtons.removeClass('d-none');
  });

  $('#users_profile_legal_legally_recognized_public_entity_false', $form).on('change', (_e) => {
    clearAndHideMultipleFieldInputs([
      $hasGovernmentOversightButtons,
      $govermentOversightInformationFields,
      $noGovernmentOversightFields,
    ]);
  });

  $('#users_profile_legal_has_government_oversight_true', $form).on('change', (_e) => {
    $govermentOversightInformationFields.removeClass('d-none');
    clearAndHideMultipleFieldInputs([$noGovernmentOversightFields]);
  });

  $('#users_profile_legal_has_government_oversight_false', $form).on('change', (_e) => {
    $noGovernmentOversightFields.removeClass('d-none');
    clearAndHideMultipleFieldInputs([$govermentOversightInformationFields]);
  });

  $('#users_profile_legal_has_appropriate_government_oversight_true', $form).on('change', (_e) => {
    $appropriateGovernmentOversightFields.removeClass('d-none');
  });

  $('#users_profile_legal_has_appropriate_government_oversight_false', $form).on('change', (_e) => {
    clearAndHideMultipleFieldInputs([$appropriateGovernmentOversightFields]);
  });

  // Publicly traded company logic

  $('#users_profile_legal_eu_publicly_traded_company_false', $form).on('change', (_e) => {
    $euAffiliatedAubliclyTradedCompanyButtons.removeClass('d-none');
  });

  $('#users_profile_legal_eu_publicly_traded_company_true', $form).on('change', (_e) => {
    clearAndHideMultipleFieldInputs([
      $euAffiliatedAubliclyTradedCompanyButtons,
      $euRegulatedPubliclyTradedCompanyButtons,
    ]);
  });

  $('#users_profile_legal_eu_affiliated_publicly_traded_company_false', $form).on('change', (_e) => {
    $euRegulatedPubliclyTradedCompanyButtons.removeClass('d-none');
  });

  $('#users_profile_legal_eu_affiliated_publicly_traded_company_true', $form).on('change', (_e) => {
    clearAndHideMultipleFieldInputs([$euRegulatedPubliclyTradedCompanyButtons]);
  });

  // Private company logic

  $('#users_profile_legal_eu_private_company_false', $form).on('change', (_e) => {
    $euRegulatedPrivateTradedCompanyButtons.removeClass('d-none');
  });

  $('#users_profile_legal_eu_private_company_true', $form).on('change', (_e) => {
    clearAndHideMultipleFieldInputs([$euRegulatedPrivateTradedCompanyButtons]);
  });
});
